import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";
import ProjectRealizationTaskModalForm from "../../Forms/ProjectRealizationTaskModalForm/ProjectRealizationTaskModalForm";
import { useTranslation } from "react-i18next";

const ProjectRealizationTaskModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:project.basicInformation"), error: false },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const formName = "ProjectRealizationTaskModal";
  const { handleHide, show } = props;

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      height={"750px"}
      width={"1200px"}
      onClose={handleHide}
      header={props.header}
      // buttons={buttons()}
      steps={steps}
    >
      <ProjectRealizationTaskModalForm
        steps={steps}
        isSubmit={isSubmit}
        step={step}
        setStep={setStep}
        setErrorHeader={setErrorHeader}
        handleHide={handleHide}
        formName={formName}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "ProjectRealizationTaskModal" })(
  ProjectRealizationTaskModal
);
